import { cx } from "@emotion/css";
import { useTranslation } from "react-i18next";
import routing from "routing";
import useSearchParams from "src/hooks/useSearchParams";
import ExamIcon from "src/images/Icons/newIcons/navigation/exams.svg";
import PickerNewItem from "src/images/Icons/newIcons/newItem.svg";
import SimulationIcon from "src/images/Icons/newIcons/simulation.svg";
import { ExamTypes } from "src/types/enums";

import { Header } from "../../../Main/ExamsBox/ExamsBox";
import { DefaultPicker } from "./DefaultPicker";

export function ExamTypePicker() {
	const { t } = useTranslation();
	const search = useSearchParams();
	const folderParam = search?.folderId ? `&folderId=${search.folderId}` : "";

	return (
		<DefaultPicker
			Header={
				<Header
					title={t("contentPicker.examType.title")}
					icon={<ExamIcon className={cx("icon-super-big icon-primary")} />}
					withBackButton
				/>
			}
			boxes={[
				{
					title: t("contentPicker.examType.basic.title"),
					subtitle: t("contentPicker.examType.basic.subtitle"),
					path: `${routing.paths.createExam}?type=${ExamTypes.BASIC}${folderParam}`,
					submitText: t("contentPicker.examType.basic.submit"),
					Icon: PickerNewItem,
				},
				{
					title: t("contentPicker.examType.simulation.title"),
					subtitle: t("contentPicker.examType.simulation.subtitle"),
					path: `${routing.paths.createExam}?type=${ExamTypes.SIMULATION}${folderParam}`,
					submitText: t("contentPicker.examType.simulation.submit"),
					Icon: SimulationIcon,
					variant: "primary",
					isNew: true,
				},
			]}
		/>
	);
}
